import { render } from "./ImagensModelo.vue?vue&type=template&id=9597af66"
import script from "./ImagensModelo.vue?vue&type=script&lang=js"
export * from "./ImagensModelo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__